import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ErrorTypes = {
  FILTERS: 'FILTERS',
  SUMMARY_PREVIEW: 'SUMMARY_PREVIEW'
};
const translate = (errorKey, options = {}) => I18n.text(`reporting-enablement.errorBoundaryMessages.${errorKey}`, options);
const messages = {
  [ErrorTypes.FILTERS]: () => ({
    title: translate(`${ErrorTypes.FILTERS}.title`),
    message: null
  }),
  [ErrorTypes.SUMMARY_PREVIEW]: () => ({
    title: translate(`${ErrorTypes.SUMMARY_PREVIEW}.title`),
    message: translate(`${ErrorTypes.SUMMARY_PREVIEW}.message`)
  })
};
const ErrorMessage = ({
  type,
  compact = false,
  'data-test-id': dataTestId = 'reporting-error-message'
}) => {
  const {
    title,
    message
  } = messages[type]();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(View, {
      padding: "200",
      marginInline: "auto",
      marginBlock: "100",
      "data-test-id": dataTestId,
      children: [/*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        typography: compact ? 'heading-100' : 'heading-300',
        marginBlockEnd: "400",
        children: title
      }), message && /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: message
      })]
    })
  });
};
ErrorMessage.propTypes = {
  type: PropTypes.oneOf(Object.keys(ErrorTypes)),
  compact: PropTypes.bool,
  ['data-test-id']: PropTypes.string
};
export default ErrorMessage;